import { mergePlain } from 'util/merge'
import { OPENED } from '../constants'
import { doUpdateState } from './doUpdateState'

export const doOpen = (ticketId, options = {}) => dispatch => {
  return dispatch(
    doUpdateState(
      ticketId,
      OPENED,
      mergePlain(
        {
          moduleOptions: {
            snackbar: {
              enabled: true,
              success: {
                enabled: true,
                message: `${app.t('Ticket')} opened`,
              },
              failed: {
                enabled: true,
                message: `Oops, we couldn't open your ${app.t('ticket')}.`,
              },
            },
          },
          meta: {
            mergeEntities: true,
          },
        },
        options
      )
    )
  )
}
